<template>
<div class="flex-container">
	<div>
		<span class="img-container round text-white text-center fs-11 lh-28 text-bolder" style="width:28px;height:28px;"
			  v-if="item.type"
			  :class="item.type===1?'bg-orange':'bg-green'"
			  v-text="item.type===1 ?'百货':'超市'"></span>
	</div>
	<div class="flex1"
		 :class="{'text-green':curr,'text-darker':!curr,'marginl20':item.type}">
		<span v-text="item.title"></span>
		<i class="icon-check marginl10" v-if="curr"></i>
	</div>
	<div class="fs-13" v-if="item.subTitle" :class="curr ? 'text-green' : 'text-darker'">
		<i class="icon-locate"></i><span class="marginl10" v-text="item.subTitle<1?Math.floor(item.subTitle*1000)+'m':Math.floor(item.subTitle)+'km'"></span>
	</div>
</div>
</template>

<script>
export default {
	props: {
		curr: {
			type: Boolean
			, default: false
		}
		, item: {
			type: Object
			, default: {}
		}
	}
};
</script>